export default __webpack_public_path__ + "static/media/r35.2676e4c7.png";